<template>
  <div class="block h-px w-full bg-neutral-200" />
</template>
